import React, { useCallback, useEffect, useRef, useState } from "react";
import { IdentityView, identityRequest } from "../../services/physicalIdentityApi";
import ScanStageStrip from "./ScanStageStrip";
import "./scan.scss";

/**
 * View Product opened from a label scan (?label=<token>): the stage strip for the making studio's owner, from the
 * same resolve the scan used, so there is no second stage endpoint. Shown only when the label is this product's
 * and the server says the viewer is the maker's owner; otherwise nothing, and the page looks as it always does.
 */
export default function ProductLabelStrip({ token, productUniqueId }: { token: string; productUniqueId: string }) {
  const [view, setView] = useState<IdentityView>();
  const generation = useRef(0);
  const load = useCallback(async () => {
    const n = ++generation.current;
    try {
      const next = await identityRequest<IdentityView>(`/resolve/${encodeURIComponent(token)}`);
      if (generation.current === n) setView(next);
    } catch {
      // The product page is still useful without its stage strip.
      if (generation.current === n) setView(undefined);
    }
  }, [token]);
  useEffect(() => {
    void load();
    const current = generation;
    return () => { current.current++; };
  }, [load]);
  if (!view || view.entityRef !== productUniqueId || view.viewerRole !== "MAKER_OWNER" || !view.stage) return null;
  return <div className="scan-page is-embedded">
    <ScanStageStrip view={view} token={token} onMoved={() => void load()} showEdit />
  </div>;
}
